import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { Site } from 'graphql-common';
import { SelectOption } from '@lib/components/Select/types';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import SiteChip from '@lib/components/SiteChip/SiteChip';
import { ChipSizes } from '@lib/components/Chip/Chip';
import styles from '../Select.module.scss';

function SiteOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti, options } = restProps;
  const value = _get(restProps, 'value', '');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const data = _get(selectedOption, 'data') as Site;
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.entityOptionChip, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <div className={styles.entityOptionChipContent}>
        <SiteChip site={data} size={ChipSizes.small} />
      </div>
    </DefaultSelectComponents.Option>
  );
}

export default SiteOption;
